import { DsButton } from '@frontends/ds';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-svh px-4 md:px-6">
      <div className="text-center">
        <h1 className="text-10xl font-bold">404</h1>
        <p className="mt-4 text-2xl">{t('page_not_found_title')}</p>
        <p className="mt-2">{t('page_not_found')}</p>
        <DsButton size="lg" className="w-full md:w-32 mt-6" onPress={() => navigate('/', { replace: true })}>
          {t('go_home')}
        </DsButton>
      </div>
    </div>
  );
};

export default NotFound;
